import Rete from 'rete'

import FileTemplate from './FileTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class FileComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.FILE)

    this.data.component = FileTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder (node) {
    node.lingualName = lingualName.FILE
    this.setConnection()

    const fileInput = new Rete.Input(CONST_SOCKET.FILE_INPUT, lang.file_socket_input_reply, this.socket.fileInput, true)
    const fileOutput = new Rete.Output(CONST_SOCKET.FILE_OUTPUT, lang.file_socket_output_next, this.socket.fileOutput, false)
    const fileOutputQuickreply = new Rete.Output(CONST_SOCKET.FILE_OUTPUT_QUICKREPLY, lang.file_socket_output_quick_replies, this.socket.fileOutputQuickreply, true)

    return node
      .addInput(fileInput)
      .addOutput(fileOutput)
      .addOutput(fileOutputQuickreply)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.FILE_OUTPUT] = node.data
  }

  setConnection() {
    // File may take connections from:
    this.socket.fileInput.combineWith(this.socket.referenceOutput)
    this.socket.fileInput.combineWith(this.socket.newPostbackOutput)
    this.socket.fileInput.combineWith(this.socket.textOutput)
    this.socket.fileInput.combineWith(this.socket.carouselOutput)
    this.socket.fileInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.fileInput.combineWith(this.socket.imageOutput)
    this.socket.fileInput.combineWith(this.socket.videoOutput)
    this.socket.fileInput.combineWith(this.socket.audioOutput)
    this.socket.fileInput.combineWith(this.socket.fileOutput)
    this.socket.fileInput.combineWith(this.socket.ecommerceOutput)
    this.socket.fileInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.fileInput.combineWith(this.socket.otnOutput)

    // File may be connected to:
    this.socket.fileOutput.combineWith(this.socket.textInput)
    this.socket.fileOutput.combineWith(this.socket.carouselInput)
    this.socket.fileOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.fileOutput.combineWith(this.socket.imageInput)
    this.socket.fileOutput.combineWith(this.socket.videoInput)
    this.socket.fileOutput.combineWith(this.socket.audioInput)
    this.socket.fileOutput.combineWith(this.socket.fileInput)
    this.socket.fileOutput.combineWith(this.socket.ecommerceInput)
    this.socket.fileOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.fileOutput.combineWith(this.socket.otnInput)
    this.socket.fileOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.fileOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.fileOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}